import { render } from "./cutBox.vue?vue&type=template&id=724887f8&scoped=true"
import script from "./cutBox.vue?vue&type=script&lang=js"
export * from "./cutBox.vue?vue&type=script&lang=js"

import "./cutBox.vue?vue&type=style&index=0&id=724887f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724887f8"]])

export default __exports__